import type React from "react"

export const Layout_2_1: React.FC<React.SVGAttributes<SVGSVGElement>> = (
  props,
) => (
  <svg
    width="22"
    height="27"
    viewBox="0 0 22 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>Layout 2-1</title>
    <path
      d="M18.2597 21.4416C18.2597 21.9938 17.812 22.4416 17.2597 22.4416H5.54972C4.99744 22.4416 4.54972 21.9938 4.54972 21.4416L4.54972 15.3377C4.54972 14.7854 4.99744 14.3377 5.54972 14.3377L17.2597 14.3377C17.812 14.3377 18.2597 14.7854 18.2597 15.3377V21.4416Z"
      fill={props.fill ?? "#2C1789"}
    />
    <path
      d="M18.2597 11.1558C18.2597 11.7081 17.812 12.1558 17.2597 12.1558L13.026 12.1558C12.4737 12.1558 12.026 11.7081 12.026 11.1558V5.05195C12.026 4.49967 12.4737 4.05195 13.026 4.05195H17.2597C17.812 4.05195 18.2597 4.49967 18.2597 5.05195V11.1558Z"
      fill={props.fill ?? "#2C1789"}
    />
    <path
      d="M10.7793 11.1558C10.7793 11.7081 10.3316 12.1558 9.77928 12.1558H5.54551C4.99323 12.1558 4.54551 11.7081 4.54551 11.1558L4.54551 5.05195C4.54551 4.49967 4.99323 4.05195 5.54551 4.05195L9.77928 4.05195C10.3316 4.05195 10.7793 4.49967 10.7793 5.05195L10.7793 11.1558Z"
      fill={props.fill ?? "#2C1789"}
    />
    <path
      d="M4.33764 26.1818H18.4675C20.4545 26.1818 22 24.6989 22 22.9091L22 3.27273C22 1.43182 20.4545 1.40898e-06 18.4675 1.23527e-06L4.33764 0C2.40583 -1.68885e-07 0.805178 1.43182 0.805177 3.27273L0.805176 22.9091C0.805176 24.6989 2.40582 26.1818 4.33764 26.1818ZM2.57141 3.27273C2.57141 2.35227 3.39933 1.63636 4.33764 1.63636L18.4675 1.63636C19.461 1.63636 20.2337 2.35227 20.2337 3.27273L20.2337 22.9091C20.2337 23.7784 19.461 24.5455 18.4675 24.5455L4.33764 24.5455C3.39933 24.5455 2.57141 23.7784 2.57141 22.9091L2.57141 3.27273Z"
      fill={props.fill ?? "#2C1789"}
    />
  </svg>
)
